import { saveAs } from 'file-saver';
import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UsersService } from '@app/api/api';
import { currentUser, User } from '@app/core/auth';
import { AppState } from '@app/core/reducers';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Observable, forkJoin, of } from 'rxjs';
import { environment } from '@app/../environments/environment';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'meu-app-info-company',
  templateUrl: './app-info-company.component.html',
  styleUrls: ['./app-info-company.component.scss'],
})
export class AppInfoCompanyComponent implements OnInit {
  @Input() userId = null;
  @Input() isAdminPage = false;
  @Input() openFromManageUser = false;
  @Output() isEditing = new EventEmitter();
  @ViewChild('fileImport', { static: false }) fileImport: ElementRef;

  constructor(
    private store: Store<AppState>,
    private userService: UsersService,
    private toastr: ToastrService,
    private ref: ChangeDetectorRef,
    private router: Router,
    private translate: TranslateService
  ) {}

  user$: Observable<User>;
  myInfo: any;
  companyInfoForm = new FormGroup({
    company_name: new FormControl('', [Validators.required, Validators.pattern('^(?!\\s*$).+')]),
    company_address: new FormControl('', [Validators.required, Validators.pattern('^(?!\\s*$).+')]),
    company_representative_name: new FormControl('', [
      Validators.required,
      Validators.pattern('^(?!\\s*$).+'),
    ]),
    company_tax_code: new FormControl('', [
      Validators.required,
      Validators.pattern('^(?!\\s*$).+'),
    ]),
    company_attachments: new FormControl(''),
  });
  lstFile: any = [];
  lstFileDelete: any = [];

  ngOnInit() {
    if (this.userId && (this.isAdminPage || this.openFromManageUser)) {
      this.getUserById(this.userId);
    } else {
      this.user$ = this.store.pipe(select(currentUser));
      this.user$.subscribe((user) => {
        this.myInfo = user;
        if (this.myInfo) {
          this.getUserById(this.myInfo.id);
        }
      });
    }
  }

  ngOnDestroy() {
    this.ref.detach();
  }

  onFileInput(ev) {
    const files = ev.target.files;
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        this.lstFile.push(files[i]);
      }
    }
    this.fileImport.nativeElement.value = '';
  }

  getUserById(id) {
    this.userService.apiUsersIdGet(id).subscribe((res) => {
      if (res.success) {
        if (this.openFromManageUser) {
          this.myInfo = res.data;
        }
        this.companyInfoForm.patchValue({
          company_name: res.data.company_name,
          company_address: res.data.company_address,
          company_representative_name: res.data.company_representative_name,
          company_tax_code: res.data.company_tax_code,
          company_attachments: res.data.company_attachments,
        });

        let arrFile = [];
        if (res.data.company_attachments && res.data.company_attachments.length > 0) {
          for (let i = 0; i < res.data.company_attachments.length; i++) {
            arrFile.push(JSON.parse(res.data.company_attachments[i]));
          }
        }
        this.lstFile = arrFile;
        this.ref.detectChanges();
      }
    });
  }

  downloadFile(url, name) {
    if (url.includes('png') || url.includes('jpg') || url.includes('jpeg') || url.includes('pdf')) {
      window.open(environment.backendhost + url);
    } else {
      var blob = new Blob([url]);
      saveAs(blob, name);
    }
  }

  updateUserInfo() {
    if (this.companyInfoForm.invalid) {
      const controls = this.companyInfoForm.controls;
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }

    const userId = this.myInfo.id;

    this.companyInfoForm.patchValue({
      company_attachments: this.lstFile.filter((f) => f.code).map((f) => JSON.stringify(f)),
    });

    this.userService.apiUsersIdPut(userId, this.companyInfoForm.value).subscribe(async (res) => {
      if (res.success) {
        try {
          if (this.lstFileDelete.length > 0) {
            for (const file of this.lstFileDelete) {
              if (file.code) {
                await this.userService
                  .apiUsersIdCompanyAttachmentCodeDelete(userId, file.code)
                  .toPromise();
              }
            }
          }

          const newFiles = this.lstFile.filter((file) => !file.path && file instanceof File);
          if (newFiles.length > 0) {
            for (const file of newFiles) {
              await this.userService.apiUsersIdCompanyAttachmentsPost(userId, file).toPromise();
            }
          }

          this.lstFileDelete = [];
          this.getUserById(userId);
          this.toastr.success(
            this.translate.instant('PROFILE.COMPANY_INFO.MESSAGES.UPDATE_SUCCESS'),
            ''
          );
          this.isEditing.emit(true);
        } catch (err) {
          console.error(err);
          this.getUserById(userId);
          this.toastr.error(
            this.translate.instant('PROFILE.COMPANY_INFO.MESSAGES.UPDATE_ERROR'),
            ''
          );
        }
      }
    });
  }

  updateUserInfoMobile() {
    if (this.openFromManageUser) {
      this.updateUserInfo();
      return;
    }
    if (this.companyInfoForm.invalid) {
      const controls = this.companyInfoForm.controls;
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }

    const userId = this.myInfo.id;

    this.companyInfoForm.patchValue({
      company_attachments: this.lstFile.filter((f) => f.code).map((f) => JSON.stringify(f)),
    });

    this.userService.apiUsersIdPut(userId, this.companyInfoForm.value).subscribe(async (res) => {
      if (res.success) {
        try {
          if (this.lstFileDelete.length > 0) {
            for (const file of this.lstFileDelete) {
              if (file.code) {
                await this.userService
                  .apiUsersIdCompanyAttachmentCodeDelete(userId, file.code)
                  .toPromise();
              }
            }
          }

          const newFiles = this.lstFile.filter((file) => !file.path && file instanceof File);
          if (newFiles.length > 0) {
            for (const file of newFiles) {
              await this.userService.apiUsersIdCompanyAttachmentsPost(userId, file).toPromise();
            }
          }

          this.lstFileDelete = [];
          this.router.navigate(['/myprofile']);
        } catch (err) {
          console.error(err);
          this.router.navigate(['/myprofile']);
          this.toastr.error(
            this.translate.instant('PROFILE.COMPANY_INFO.MESSAGES.UPDATE_ERROR'),
            ''
          );
        }
      }
    });
  }

  getIconFile(name) {
    const ext = name.split('.').pop().toLowerCase();
    if (['png', 'jpg', 'jpeg'].includes(ext)) return 'file-image.svg';
    if (['doc', 'docx'].includes(ext)) return 'file-word.svg';
    if (['xlsx', 'xls'].includes(ext)) return 'file-excel.svg';
    if (ext === 'pdf') return 'file-pdf.svg';
    return 'file-other.svg';
  }

  deletefile(index) {
    const file = this.lstFile[index];
    if (file && file.code) {
      this.lstFileDelete.push(file);
    }
    this.lstFile.splice(index, 1);
    this.ref.detectChanges();
  }
}
